import { lazy } from 'react';

export const LazyHandoffCompleted = lazy(() =>
  import(/* webpackChunkName: "handoff-completed" */ './HandoffCompleted').then((module) => ({
    default: module.HandoffCompletedConnected,
  }))
);
